<!--=============================
=            CONTACT            =
==============================-->

<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Contact</div>
      </base-header>
    </v-row>
    <v-row>
      <v-col cols="12" md="4" sm="12" v-for="item in contacts" :key="item.id">
        <base-card>
          <div slot="card-header">
            <v-row>

              <v-list-item three-line>
                <v-list-item-avatar tile class=" rounded-lg" size="60"> <img alt="user" style="width:50px;height:50px"
                       :src="require(`../../assets/images/users/${item.img}.jpg`)"></v-list-item-avatar>
                <v-list-item-content>

                  <v-list-item-title class="subtitle- font-weight-black white--text ">
                    {{item.name}}
                  </v-list-item-title>
                  <v-list-item-subtitle class="mt-n2  white--text ">{{item.office}}</v-list-item-subtitle>
                </v-list-item-content>


              </v-list-item>
            </v-row>

            <v-divider class="mx-4 grey--text"></v-divider>


            <v-list class="transparent" dark dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="white">
                    mdi-phone
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title class="subtitle-2  font-italic">{{item.phone}}</v-list-item-title>
                  <v-list-item-subtitle class="text-caption font-italic">Mobile</v-list-item-subtitle>
                </v-list-item-content>


              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="white">
                    mdi-email
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title class="subtitle-2 font-italic">{{item.email}}</v-list-item-title>
                  <v-list-item-subtitle class="text-caption font-italic">Personal</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>



              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="white">
                    mdi-map-marker
                  </v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title class="subtitle-2 font-italic">1400 Main Street</v-list-item-title>
                  <v-list-item-subtitle class="text-caption font-italic">Orlando, FL 79938
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>


          </div>
          <div slot="card-body">
            <v-row class="mb-5">
              <v-col cols="12" sm="12" md="12" class="py-2 text-center">


                <v-btn-toggle v-model="toggle_exclusive">
                  <v-btn color="blue darken-3 " class="white--text">
                    <v-icon class="white--text" dark>mdi-facebook</v-icon>
                  </v-btn>

                  <v-btn color="pink" class="white--text" dark>
                    <v-icon class="white--text" dark>mdi-instagram</v-icon>
                  </v-btn>

                  <v-btn color="cyan" class="white--text" dark>
                    <v-icon class="white--text" dark>mdi-twitter</v-icon>
                  </v-btn>

                  <v-btn color="lime darken-2" class="white--text">
                    <v-icon class="white--text" dark>whatsapp</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    data() {
      return {
        toggle_exclusive: 2,
        contacts: [{
            img: '3',
            name: 'Paulo Silva',
            office: 'Design',
            phone: '5584-5822',
            email: 'paulo@example.com'

          },
          {
            img: '4',
            name: 'Gustavo MArtins',
            office: 'Design',
            phone: '5584-5822',
            email: 'gustavomartins@example.com'

          },
          {
            img: '5',
            name: 'Silvana Oliveira',
            office: 'Teacher',
            phone: '8584-1422',
            email: 'sil2@example.com'

          },
          {
            img: '6',
            name: 'Jose Wintons',
            office: 'Design',
            phone: '5584-5822',
            email: 'josew@example.com'

          },
          {
            img: '7',
            name: 'Ana Paula',
            office: 'Design',
            phone: '5584-5822',
            email: 'ap@example.com'

          }, {
            img: '8',
            name: 'Helen Souza',
            office: 'Design',
            phone: '5584-5822',
            email: 'helen@example.com'

          },


        ],
      }
    },

  }
</script>

<!--====  End of CONTACT  ====-->